import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Global blocking modal shown when the backend rejects a non-AU profile on
 * the AU instance (COUNTRY_MISMATCH). The session has already been ended by
 * AuthContext — this only communicates the reason and points the user to
 * their correct HandyHub site. It cannot be dismissed into a dashboard.
 */
export const CountryBlockModal = () => {
  const { countryBlock, clearCountryBlock, signOut } = useAuth();

  if (!countryBlock) return null;

  const message =
    countryBlock.message ||
    'This account is registered with HandyHub New Zealand. Please sign in at handyhub.co.nz.';
  const loginUrl = countryBlock.login_url || 'https://handyhub.co.nz/login';

  const handleClose = async () => {
    try { await signOut(); } catch { /* ignore */ }
    clearCountryBlock();
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="country-block-title"
    >
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl border border-slate-200 overflow-hidden">
        <div className="bg-amber-500 h-1.5 w-full" />
        <div className="p-7">
          <div className="flex items-center gap-3 mb-4">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
            </div>
            <h2 id="country-block-title" className="text-lg font-bold text-slate-900">
              Wrong HandyHub site
            </h2>
          </div>

          <p className="text-slate-600 text-[15px] leading-relaxed mb-6">
            {message}
          </p>

          <a
            href={loginUrl}
            className="block w-full text-center rounded-lg bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold px-4 py-3 transition-colors"
          >
            Go to HandyHub New Zealand →
          </a>

          <button
            type="button"
            onClick={handleClose}
            className="mt-3 block w-full text-center rounded-lg border border-slate-200 hover:bg-slate-50 text-slate-600 font-medium px-4 py-2.5 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountryBlockModal;
